import React from "react";
import { Card, CardContent, CardMedia, Chip, Typography, IconButton } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const TabCard = ({ 
  product, 
  selectedCurrency, 
  handleCardClick ,
  hoveredProductId,
  setHoveredProductId,
  isHovered,
}) => {
  return (
    <Card
      elevation={0}
      sx={{
       
        // backgroundColor: "#f3f3f3",
        border: "1px solid transparent",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: 1,
        borderRadius: "0px",
        position: "relative",
        // transition: "transform 0.3s, box-shadow 0.3s",
        cursor: "pointer",
        height: "100%", 
        "&:hover": {
        //   transform: "translateY(-4px)",
        //   boxShadow: 4,
        border: "1px solid #9E6747",
        },
      }}
      onClick={() => handleCardClick(product.id)}
      onMouseEnter={() => setHoveredProductId(product.id)}
      onMouseLeave={() => setHoveredProductId(null)}
    >
      {/* Sold Out Chip */}
      {product?.soldOut && (
        <Chip
          label="Sold Out"
          color="error"
          sx={{ position: "absolute", top: 16, left: 16 }}
        />
      )}
      {/* Discount Chip */}
      {product.discount && (
        <Chip
          label={`-${product.discount}%`}
          color="primary"
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            backgroundColor: "#ff4646",
            color: "white",
            padding: "4px 8px",
            borderRadius: "0px",
            fontWeight: "bold",
            zIndex: 1,
            fontSize: "14px",
            transition: "opacity 0.3s ease, visibility 0.3s ease",
            opacity: hoveredProductId === product.id ? 0 : 1,
            visibility: hoveredProductId === product.id ? "hidden" : "visible",
          }}
        />
      )}

      {/* Product Image */}
      <CardMedia
        component="img"
        image={product.image}
        alt={product.title}
        sx={{
          width: "80%",
          height: 200,         // Fixed height for all images
          objectFit: "cover",
        //   marginRight: 2,
       
            
          borderRadius: 0, 
          transition: "transform 0.3s ease", // Smooth transition
         
          "&:hover": {
           
               transform: "scale(1.05)", // Scale the image slightly
            transition: "opacity 0.5s ease",
            },
        }}
      />

      {/* Product Details */}
      <CardContent sx={{  paddingLeft: 0 }}>
        <Typography
          variant="caption"
          color="textSecondary"
          textTransform="uppercase" 

        >
          {product.category_name}
        </Typography>
        
        <Typography variant="h6" gutterBottom>
          {product?.name.length > 20
            ? product?.name.slice(0, 20) + "..."
            : product?.name}
        </Typography>
        <Typography variant="h6" color="primary" fontSize={"12px"}
              // fontWeight="600"
              sx={{
                fontFamily: "'Nunito Sans', sans-serif", // Font family
              }}>
          {selectedCurrency.code === "Rs"
            ? `${product.currency} ${(product.price * (1 - product.discount / 100)).toFixed(2)}`
            : `${selectedCurrency.code} ${((product.price * (1 - product.discount / 100)) / parseFloat(selectedCurrency.ratio)).toFixed(2)}`
          }
        </Typography>
        {product.originalPrice && (
          <Typography
          variant="h6"
          fontSize={"12px"}
          // fontWeight="600"
          color={"#bebebe"}
          sx={{
            fontFamily: "'Nunito Sans', sans-serif", // Font family
            marginRight: "8px",
            textDecoration: "line-through",
            color: "#828382",
          }}
          >
            {selectedCurrency.code === "Rs"
              ? `${product.currency} ${product.originalPrice}`
              : `${selectedCurrency.code} ${(product.originalPrice / parseFloat(selectedCurrency.ratio)).toFixed(2)}`
            }
          </Typography>
        )}
      </CardContent>

      
    </Card>
  );
};

export default TabCard;
